import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { Box, IconButton, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const colors = useColors();

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (page) => {
    onPageChange(page);
  };

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pageNumbers = [];

    // Always show page 1
    pageNumbers.push(1);

    // Calculate range around current page
    let startPage = Math.max(2, currentPage - 1);
    let endPage = Math.min(totalPages - 1, currentPage + 1);

    // Add ellipsis after page 1 if needed
    if (startPage > 2) {
      pageNumbers.push("...");
    }

    // Add pages around current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Add ellipsis before last page if needed
    if (endPage < totalPages - 1) {
      pageNumbers.push("...");
    }

    // Always show last page if there is more than one page
    if (totalPages > 1) {
      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <IconButton onClick={handlePreviousPage} disabled={currentPage === 1}>
        <ArrowBackIosRoundedIcon
          sx={{ fontSize: "18px", color: colors.text_primary }}
        />
      </IconButton>

      {getPageNumbers().map((page, index) =>
        page === "..." ? (
          <Typography key={`ellipsis-${index}`} variant="body2" sx={{ mx: 1 }}>
            {page}
          </Typography>
        ) : (
          <Typography
            key={`page-${page}`}
            variant="body2"
            sx={{
              mx: 1,
              color: colors.text_primary,
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "8px",
              backgroundColor:
                currentPage === page ? colors.grey_8percent : "transparent",
            }}
            onClick={() => handlePageClick(page)}
          >
            {page}
          </Typography>
        )
      )}

      <IconButton
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <ArrowForwardIosRoundedIcon
          sx={{ fontSize: "18px", color: colors.text_primary }}
        />
      </IconButton>
    </Box>
  );
};

export default Pagination;
